<div class="swiper">
    <div class="slides-container" #slideContainer>
        <div class="slides" [ngStyle]="{'transform': 'translateX(' + (-getSlideOffset()) + 'px)'}">
            <div class="slide" *ngFor="let slide of slides; let i = index" (click)="onEvent(slide)">
                <img [src]="slide" alt="Slide">
            </div>
        </div>
    </div>
    <div class="prev">
        <app-button  [buttonClass]="'only-icon-light-gray'" (buttonClick)="prevSlide()" [icon]="'assets/images/new-design-icons/Arrow Left (white).svg'" [iconDirection]="'left'"></app-button>
    </div>
    <div class="next">
        <app-button  [buttonClass]="'only-icon-light-gray'" (buttonClick)="nextSlide()" [icon]="'assets/images/new-design-icons/Arrow Right (white).svg'" [iconDirection]="'left'"></app-button>
    </div>
</div>